// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Fzpt","buttons":"PendingPaymentAlert_buttons__3zRB1"};